var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"py-3 py-lg-5 col-12"})}
var staticRenderFns = []

export { render, staticRenderFns }